<template lang="pug">
#PageResultAerialLog
    //- Header Global
    .change-on-mobile
        button.mobile-only.overlay-button(
            v-on:click="toggleSidebar()"
        )
            .btn-change-menu
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg>
        HeaderGlobal(HeaderGlobalHeading="Aerial Log" :HeaderGlobalBreadcrumb="breadcrumb")

    //- banner filter
    ResultFilter
    //- end banner filter

    //- Aerial log
    .flex.flex-wrap(class=" lg:-mx-3")
        .block(class="w-full lg:px-3 lg:w-5/12")
            .box
                header.flex.items-center.justify-between.box__header.no-border
                    .header-meta
                        h2.subheading Top Aerial Log
                .box__body(style="padding:0px")
                    .box-tabs
                        vue-tabs
                            v-tab(title="City")
                                AerialCity
                            v-tab(title="Province")
                                AerialProvince
                            v-tab(title="Region")
                                AerialRegion
                            v-tab(title="Village")
                                AerialVillage
        .block.px-3(class="w-full lg:px-3 lg:w-7/12 mt-4 lg:mt-0")
            template(v-if="load_data_status_aerial_log.status === 'loading'")
                Loading(show="true")

            .box-map(style="height: 530px" v-else)
                template(v-if="aerial_log.heatmap && aerial_log.heatmap.length > 0 && mapLoaded")

                    l-map(v-if="vendorMap==='osm'" ref="mapRefOSM" :id="idOsm" :zoom="10" :center="center" :options="options" style="height: 100%;width: 100%;")
                        l-tile-layer(:url="url" :attribution="attribution")
                        l-marker(v-if="showMarkerOsm" v-for="(location, index) in locations" :lat-lng="location.position" v-bind:key="index")
                            l-popup(:content="location.name")
                        l-polyline(v-if="showPolylineOsm" :lat-lngs="polylineOsm.latlngs" :color="polylineOsm.color")
                        LeafletHeatmap(v-if="latLngHeat.length > 0 && showHeatmapOsm" :lat-lng="latLngHeat" :max="maxHeat" :radius="radHeat" :maxZoom="10")
                        l-control(position="topleft")
                            .found-result.is-show
                                .found-result__body
                                    .flex.wrap.items
                                        .item-4.mr-4
                                            span Marker
                                            br
                                            .wrapper-checkbox
                                                input(id="toggle_marker" name="marker" type="checkbox" checked v-model="showMarkerOsm")
                                                .ui-checkbox.flex.items-center
                                                    .checkbox.flex.items-center.justify-center
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>

                                        .item-4.mr-4
                                            span Lines
                                            br
                                            .wrapper-checkbox
                                                // input(id="toggle_lines" name="lines" type="checkbox" checked)
                                                input(id="toggle_lines" name="lines" type="checkbox" checked v-model="showPolylineOsm")
                                                .ui-checkbox.flex.items-center
                                                    .checkbox.flex.items-center.justify-center
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>

                                        .item-4.mr-4
                                            span Heatmap
                                            br
                                            .wrapper-checkbox
                                                input(id="toggle_heatmap" name="heatmap" type="checkbox" checked v-model="showHeatmapOsm")
                                                .ui-checkbox.flex.items-center
                                                    .checkbox.flex.items-center.justify-center
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>

                                .found-result__footer.mb-4(id="map__footer")
                                    
                                    span Heatmap Radius (meter)
                                    .list-size.field
                                        select.map-filter.field-style(id="radius-size" name="radius-size" @change="radiusHeatmap($event)")
                                            option(value="10") 10
                                            option(value="20") 20
                                            option(value="30" selected) 30
                                            option(value="40") 40
                                        div(class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700")
                                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>

                    gmap-map#map(v-else ref="mapRef" :center="center" :zoom="10" :options="options" style="width:100%; height: 100%;")

                NoDataAvailable(v-else)

</template>

<script>
import HeaderGlobal from './../../components/HeaderGlobal.vue';
import ResultFilter from './../result/ResultFilter.vue';
import {VueTabs, VTab} from 'vue-nav-tabs';
import { mapState } from 'vuex';
import { gmapApi } from 'vue2-google-maps';

import Loading from '@/components/Loading.vue';
import NoDataAvailable from '@/components/NoDataAvailable.vue';
import AerialCity from './../../pages/result/aerial/AerialCity.vue';
import AerialProvince from './../../pages/result/aerial/AerialProvince.vue';
import AerialRegion from './../../pages/result/aerial/AerialRegion.vue';
import AerialVillage from './../../pages/result/aerial/AerialVillage.vue';

// openmapstreet
import {LMap, LTileLayer, LMarker, LPopup, LPolyline, LControl} from 'vue2-leaflet';
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
// import LeafletHeatmap from 'vue2-leaflet-heatmap';
import LeafletHeatmap from '@/components/LeafletHeatmap.vue';
// import 'leaflet.heat';
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.imagePath = ''
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

import EventEmit from "./event.js";
/* eslint-disable no-unused-vars */
function yourJavascriptFunction() {
    EventEmit.$emit("fetchdata");
}

function callingVuejsFunction(data) {
    var event = new CustomEvent("hakunaMatata",{ 
        detail:  {
            message: "naiveTechNoobs",
            info: data
    }});
}

export default {
    name: 'HistoryApp',
    components: {
        HeaderGlobal,
        ResultFilter,
        VueTabs,
        VTab,
        Loading,
        NoDataAvailable,
        AerialCity,
        AerialProvince,
        AerialRegion,
        AerialVillage,

        // open street map
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        LeafletHeatmap,
        LPolyline,
        LControl,
    },
    props: ['resultGlobalBreadcrumb'],
    data() {
        return {
            breadcrumb: [
                this.resultGlobalBreadcrumb,
                {
                    name: 'Aerial Log',
                    url: '/result/aerial-log',
                },
            ],
            options: {
                // zoomControl: true,
                // mapTypeControl: true,
                // scaleControl: true,
                // streetViewControl: true,
                // rotateControl: true,
                // fullscreenControl: false,
                // disableDefaultUi: false
                // scrollwheel: false,
                gestureHandling: 'cooperative',
                styles: [
                    {elementType: 'geometry', stylers: [{color: '#242f3e'}]},
                    {elementType: 'labels.text.stroke', stylers: [{color: '#242f3e'}]},
                    {elementType: 'labels.text.fill', stylers: [{color: '#746855'}]},
                    {
                      featureType: 'administrative.locality',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#d59563'}]
                    },
                    {
                      featureType: 'poi',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#d59563'}]
                    },
                    {
                      featureType: 'poi.park',
                      elementType: 'geometry',
                      stylers: [{color: '#263c3f'}]
                    },
                    {
                      featureType: 'poi.park',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#6b9a76'}]
                    },
                    {
                      featureType: 'road',
                      elementType: 'geometry',
                      stylers: [{color: '#38414e'}]
                    },
                    {
                      featureType: 'road',
                      elementType: 'geometry.stroke',
                      stylers: [{color: '#212a37'}]
                    },
                    {
                      featureType: 'road',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#9ca5b3'}]
                    },
                    {
                      featureType: 'road.highway',
                      elementType: 'geometry',
                      stylers: [{color: '#746855'}]
                    },
                    {
                      featureType: 'road.highway',
                      elementType: 'geometry.stroke',
                      stylers: [{color: '#1f2835'}]
                    },
                    {
                      featureType: 'road.highway',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#f3d19c'}]
                    },
                    {
                      featureType: 'transit',
                      elementType: 'geometry',
                      stylers: [{color: '#2f3948'}]
                    },
                    {
                      featureType: 'transit.station',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#d59563'}]
                    },
                    {
                      featureType: 'water',
                      elementType: 'geometry',
                      stylers: [{color: '#17263c'}]
                    },
                    {
                      featureType: 'water',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#515c6d'}]
                    },
                    {
                      featureType: 'water',
                      elementType: 'labels.text.stroke',
                      stylers: [{color: '#17263c'}]
                    }
                ],
            },
            infoWindows: [],
            mapLoaded: false,
            // mapLoaded: true,
            center: {},
            markers: [],
            // places: [],
            heatmap: null,
            mapsLatLng: [],
            polyline: null,

            vendorMap: (typeof process.env.VUE_APP_VENDOR_MAP!==undefined? process.env.VUE_APP_VENDOR_MAP: 'gmap'),

            // open street maps
            // url: 'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png',
            url: `${process.env.VUE_APP_OSM_CDN_URL}{z}/{x}/{y}.png`,
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            locations: [],
            idOsm: 'openstreetmap-aerial_log',
            polylineOsm: {
                latlngs:[],
                color:'red'
            },
            newLoc: '',
            newLt : 0, 
            newLng : 0,
            icon: L.icon({iconUrl: "null",}),
            latLngHeat: [],
            maxHeat: 1.0,
            radHeat: 30,

            showMarkerOsm: true,
            showPolylineOsm: true,
            showHeatmapOsm: true,
        };
    },
    computed: {
        ...mapState([
            'load_data_status_aerial_log',
            'aerial_log',
        ]),
        google: gmapApi,
        key() {
            return this.$route.params.key;
        },
        isKey() {
            return this.key ? true : false;
        },
    },
    watch: {
        aerial_log() {
            this.startMap();
        },
        google() {},
        key() {},
        isKey() {},
    },
    methods: {
        toggleSidebar() {
            EventEmit.$emit('toggleSidebar')
        },
        hideAllInfoWindows() {
            for (var i=0; i < this.infoWindows.length; i++) {
                this.infoWindows[i].close();
            }
        },
        toggleMarker(e) {
            // this.setMapOnAll((e.target.checked) ? 'map' : null);
            var self = this;
            switch(self.vendorMap) {
                case 'osm':
                    if (e.target.checked) {
                        this.showMarkerOsm = true;
                    } else {
                        this.showMarkerOsm = false;
                    }
                    break;

                default:
                    self.$nextTick(() => {
                        self.$refs.mapRef.$mapPromise.then((map) => {

                            const google = self.google;

                            // map.center = new google.maps.LatLng(self.center);

                            for (var i = 0; i < self.markers.length; i++) {
                              // self.markers[i].setMap(map);

                                if (e.target.checked) {
                                self.markers[i].setVisible(true);
                                } else {
                                    self.markers[i].setVisible(false);
                                }
                            }

                        });
                    });
            }
        },
        toggleLines(e=null) {
            // polyline.setMap(polyline.getMap() ? null : map);
            var self = this;
            switch(self.vendorMap) {
                case 'osm':
                    if (e.target.checked) {
                        self.showPolylineOsm = true;
                    } else {
                        self.showPolylineOsm = false;
                    }
                    break;

                default:
                    self.$nextTick(() => {
                        self.$refs.mapRef.$mapPromise.then((map) => {
                            self.polyline.setMap(self.polyline.getMap() ? null : map);
                        });
                    });
            }
        },
        toggleHeatmap(e=null) {
            // heatmap.setMap(heatmap.getMap() ? null : map);
            var self = this;
            switch(self.vendorMap) {
                case 'osm':
                    if (e.target.checked) {
                        self.showHeatmapOsm = true;
                    } else {
                        self.showHeatmapOsm = false;
                    }
                    break;

                default:
                    self.$nextTick(() => {
                        self.$refs.mapRef.$mapPromise.then((map) => {
                            self.heatmap.setMap(self.heatmap.getMap() ? null : map);
                        });
                    });
            }

        },
        radiusHeatmap(e) {
            var self = this;
            switch(self.vendorMap) {
                case 'osm':
                    self.radHeat = parseInt(e.target.value);
                    break;

                default:
                    self.$nextTick(() => {
                        self.$refs.mapRef.$mapPromise.then((map) => {
                            self.heatmap.set('radius', e.target.value);
                        });
                    });
            }
        },
        // setMapOnAll(maps) {
        //     // if (map == 'map') {
        //         var self = this;

        //         self.$nextTick(() => {
        //             self.$refs.mapRef.$mapPromise.then((map) => {

        //                 const google = self.google;

        //                 map.center = new google.maps.LatLng(self.center);

        //                 for (var i = 0; i < self.markers.length; i++) {
        //                   // self.markers[i].setMap(map);

        //                   if (maps == 'map') {
        //                     self.markers[i].setVisible(true);
        //                   } else {
        //                     self.markers[i].setVisible(false);
        //                   }
        //                 }

        //             });
        //         });
        //     // }
        // },
        startMap() {
            switch(this.vendorMap) {
              case 'osm':
                this.startMapOSM();
                break;
              default:
                this.startMapGMAP();
                break;
            }
        },
        startMapGMAP() {
            var self = this;
            self.mapsLatLng = [];
            self.markers = [];
            self.infoWindows = [];

            if (this.aerial_log.heatmap && this.aerial_log.heatmap.length > 0 && this.isKey) {

                var heatmap_data = this.aerial_log.heatmap;
                // var heatmap;
                // var mapsLatLng = [];
                // var polyline;

                var lat = parseFloat(heatmap_data[0][0]);
                var lng = parseFloat(heatmap_data[0][1]);

                this.center = {
                    lat: lat,
                    lng: lng,
                };

                this.mapLoaded = true;

                self.$nextTick(() => {
                    self.$refs.mapRef.$mapPromise.then((map) => {
                        const google = self.google;

                        map.center = new google.maps.LatLng(self.center);

                        Object.keys(heatmap_data).forEach(function(k){
                            self.mapsLatLng[k] = new google.maps.LatLng(heatmap_data[k][0],heatmap_data[k][1]);
                            var marker = new google.maps.Marker({
                                position: new google.maps.LatLng(heatmap_data[k][0],heatmap_data[k][1]),
                                map: map 
                            });

                            self.markers.push(marker);
                            
                            var contentString = '<div id="content">'+
                                  '<div id="bodyContent">'+
                                  '<p>Link Location: <a target="_blank" href="https://www.google.com/maps?q='+heatmap_data[k][0]+','+heatmap_data[k][1]+'" style="color: #43ea92;">'+
                                  'Google Maps</a> '+
                                  '</p>'+
                                  '<p>Date: '+heatmap_data[k][2]+'</p>'+
                                  '</div>'+
                                  '</div>';

                            var infowindow = new google.maps.InfoWindow({
                                content: contentString,
                                maxWidth: 200
                            });
                            
                            self.infoWindows.push(infowindow); 
                            
                            google.maps.event.addListener(marker, 'click', function() {
                              // hideAllInfoWindows(map);
                              self.hideAllInfoWindows();
                              infowindow.open(map, marker);
                            });
                        });

                        self.heatmap = new google.maps.visualization.HeatmapLayer({
                          data: self.mapsLatLng
                        });

                        self.polyline = new google.maps.Polyline({
                          path: self.mapsLatLng,
                          strokeColor: '#FF0000',
                          strokeOpacity:0.8,
                          strokeWeight:1.5
                        });

                        self.polyline.setMap(map);
                        self.heatmap.setMap(map);
                        self.heatmap.set('radius', 30);

                        var bounds = new google.maps.LatLngBounds();

                        // Extend bounds with each point
                        for (var i = 0; i < self.mapsLatLng.length; i++) {
                            bounds.extend(self.mapsLatLng[i]);
                        }

                        // Apply fitBounds
                        map.fitBounds(bounds); 

                        // controlDiv.classList.add('is-show')
                        
                        var toggle_box = '<div class="found-result is-show" style="display: none;">';
                        toggle_box += '<div class="found-result__body">';
                        toggle_box += '<div class="flex wrap items">';
                        toggle_box += '<div class="item-4 m:item-4">';
                        toggle_box += '<span>Marker</span>';
                        toggle_box += '<br>';
                        // toggle_box += '<label class="switch">';
                        // toggle_box += '<input onclick="toggleMarker(this)" name="marker" type="checkbox" checked>';
                        // toggle_box += '<span class="slider round"></span>';
                        // toggle_box += '</label>';
                        toggle_box += '<div class="wrapper-checkbox"><input id="toggle_marker" name="marker" type="checkbox" checked><div class="ui-checkbox flex items-center"><div class="checkbox flex items-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg></div></div></div>';

                        toggle_box += '</div>';
                        toggle_box += '<div class="item-4 m:item-4">';
                        toggle_box += '<span>Lines</span>';
                        toggle_box += '<br>';
                        // toggle_box += '<label class="switch">';
                        // toggle_box += '<input onclick="toggleLines()" name="lines" type="checkbox" checked>';
                        // toggle_box += '<span class="slider round"></span>';
                        // toggle_box += '</label>';
                        toggle_box += '<div class="wrapper-checkbox"><input id="toggle_lines" name="lines" type="checkbox" checked><div class="ui-checkbox flex items-center"><div class="checkbox flex items-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg></div></div></div>';

                        toggle_box += '</div>';
                        toggle_box += '<div class="item-4 m:item-4">';
                        toggle_box += '<span>Heatmap</span>';
                        toggle_box += '<br>';
                        // toggle_box += '<label class="switch">';
                        // toggle_box += '<input onclick="toggleHeatmap()" name="heatmap" type="checkbox" checked>';
                        // toggle_box += '<span class="slider round"></span>';
                        // toggle_box += '</label>';
                        toggle_box += '<div class="wrapper-checkbox"><input id="toggle_heatmap" name="heatmap" type="checkbox" checked><div class="ui-checkbox flex items-center"><div class="checkbox flex items-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg></div></div></div>';

                        toggle_box += '</div>';
                        toggle_box += '</div>';
                        toggle_box += '</div>';
                        toggle_box += '<div class="found-result__footer" id="map__footer">';
                        toggle_box += '<span>Heatmap Radius (meter)</span>';
                        toggle_box += '<div class="list-size field">';
                        toggle_box += '<select class="map-filter field-style" id="radius-size" ';
                        toggle_box += 'name="radius-size">';
                        toggle_box += '<option value="10">10</option>';
                        toggle_box += '<option value="20">20</option>';
                        toggle_box += '<option value="30" selected>30</option>';
                        toggle_box += '<option value="40">40</option>';
                        toggle_box += '</select>';
                        // icon arrow bottom
                        toggle_box += '<div class=" pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"><svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg></div>'
                        toggle_box += '</div>';
                        toggle_box += '</div>';
                        toggle_box += '</div>';


                        // .field.mb-4
                        //     label.block.text-sm.font-bold.mb-2(for="fieldSelect") Field Select
                        //     .relative
                        //         select.field-style
                        //             option Opstion A
                        //             option Opstion B
                        //             option Opstion C
                        //             option Opstion D
                        //         .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                        //             <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>

                        var get_map = document.getElementById('map');
                        // console.log(get_map)

                        var el = document.createElement( 'div' );
                        el.innerHTML = toggle_box;

                        this.btnToggleMarker = el.querySelector('#toggle_marker')
                        this.btnToggleMarker.addEventListener('change', this.toggleMarker)

                        this.btnToggleLines = el.querySelector('#toggle_lines')
                        this.btnToggleLines.addEventListener('change', this.toggleLines)

                        this.btnToggleHeatmap = el.querySelector('#toggle_heatmap')
                        this.btnToggleHeatmap.addEventListener('change', this.toggleHeatmap)

                        this.btnRadiusHeatmap = el.querySelector('#radius-size')
                        this.btnRadiusHeatmap.addEventListener('change', this.radiusHeatmap)
                        

                        get_map.after(el);

                        var controlDiv = document.querySelector('.found-result');
                        map.controls[google.maps.ControlPosition.LEFT_TOP].push(controlDiv);

                        setTimeout(function(){
                            controlDiv.style.display = 'inline';
                        }, 1050);
                    });
                });
            }
        },
        startMapOSM() {
            var self = this;
            self.locations = [];
            self.latLngHeat = [];
            self.polylineOsm.latlngs = [];

            if (this.aerial_log.heatmap && this.aerial_log.heatmap.length > 0 && this.isKey) {

                var heatmap_data = this.aerial_log.heatmap;
                // var heatmap;
                // var mapsLatLng = [];
                // var polyline;

                var lat = parseFloat(heatmap_data[0][0]);
                var lng = parseFloat(heatmap_data[0][1]);

                this.center = {
                    lat: lat,
                    lng: lng,
                };

                this.mapLoaded = true;

                self.$nextTick(() => {
                    const map = self.$refs.mapRefOSM.mapObject
                    var bounds = [];

                    var heatmapData = {};
                    var maxValue = 0;
                    var heatmapDataFix = [];

                    Object.keys(heatmap_data).forEach(function(k){
                        let latTmp = parseFloat(heatmap_data[k][0]);
                        let lngTmp = parseFloat(heatmap_data[k][1]);
                        let centerTmp = [latTmp, lngTmp];

                        var contentString = '<div id="content">'+
                          '<div id="bodyContent">'+
                          '<p>Link Location: <a target="_blank" href="https://www.google.com/maps?q='+heatmap_data[k][0]+','+heatmap_data[k][1]+'" style="color: #43ea92;">'+
                          'Google Maps</a> '+
                          '</p>'+
                          '<p>Date: '+heatmap_data[k][2]+'</p>'+
                          '</div>'+
                          '</div>';
                        
                        self.locations.push({
                            name:contentString,
                            position:centerTmp, 
                        });

                        self.polylineOsm.latlngs.push(centerTmp)
                        // self.polyline.color = labelColor

                        if (heatmapData[latTmp+','+lngTmp]){
                            heatmapData[latTmp+','+lngTmp][2] += 1;
                        } else {
                            heatmapData[latTmp+','+lngTmp] = [latTmp, lngTmp, 1];
                        }

                        if (maxValue < heatmapData[latTmp+','+lngTmp][2]){
                            maxValue = heatmapData[latTmp+','+lngTmp][2]
                        }

                        bounds.push(centerTmp);
                    });

                    if (maxValue > 0){
                        Object.values(heatmapData).forEach(function(arr) {
                            arr[2] = arr[2]/maxValue;
                            heatmapDataFix.push(arr);
                        });
                        // console.log({heatmapDataFix})
                        self.latLngHeat = heatmapDataFix;
                    }

                    if (bounds.length)
                        map.fitBounds(L.latLngBounds([bounds]));
                });
            }
        },
        async fetchData() {
            console.log('hoooray :)');
        },
    },
    created() {
        /* eslint-disable no-unused-vars */
        EventEmit.$on("fetchData", group => {
            this.fetchData();
        });
        // window.hakunaMatata = this.fetchData();
    },
    mounted() {
        this.startMap();
        // window.addEventListener('hakunaMatata', this.fetchData())
    },
}
</script>

<style lang="sass">
    .list-area
        max-height: 400px
        overflow: scroll

    .found-result
        background-color: rgba(255,255,255,.8)
        margin-left: 10px
        height: auto !important
        padding: 17px !important
        width: 230px !important
        span
            color: #000 !important
            font-size: 1.2em

    @media screen and (max-width: 480px)
        .found-result
            height: 25% !important

    // #map__footer
    //     display: none

    .map-filter
        height: 32px
        margin-right: 8px
        border: none
        text-align: center
        width: 100%

</style>
